export enum AppCustomEvent {
  CookieConsentChange = 'cookie-consent-change',
}
